import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const IndirSaleChbkLedgerPymtList = ({ indirSaleId, pymtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (indirSaleId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('indirSaleId', indirSaleId));
      }

      if (pymtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pymtId', pymtId));
      }
    },
    [indirSaleId, pymtId],
  );

  return <EntityList entity="INDIR_SALE_CHBK_LEDGER_PYMT" augRowsReq={augRowsReq} />;
};
